module.exports = __webpack_public_path__ + "static/img/10.e51365f2.png";